import { render, staticRenderFns } from "./WorkflowFormPreview.vue?vue&type=template&id=686b70b8"
import script from "./WorkflowFormPreview.vue?vue&type=script&lang=js"
export * from "./WorkflowFormPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports